


/* Single image */
import simg1 from '../images/service-single/1.png'
import simg2 from '../images/service-single/2.jpg'
import simg3 from '../images/service-single/3.jpg'
import simg4 from '../images/service-single/4.jpg'

/* icon image */
import icon1 from '../images/service/1.svg'
import icon2 from '../images/service/2.svg'
import icon3 from '../images/service/3.svg'
import icon4 from '../images/service/4.svg'


const Services = [
    {
        id: 1,
        icon: icon1,
        simage: simg1,
        title: 'La rivoluzione pulita',
        description: 'Dimentica la paletta e gli odori sgradevoli. Kleeo si prende cura dell\'igiene del tuo gatto in totale autonomia, regalandoti più tempo libero per le coccole.',
        slug: 'la-rivoluzione-pulita'
    },
    {
        id: 2,
        icon: icon2,
        simage: simg2,
        title: 'Igiene Totale & Deodorizzazione',
        description: 'Il sistema a pressione negativa con purificazione ionica elimina gli odori prima che escano dalla lettiera. Aria sempre fresca, garantita.',
        slug: 'Igiene-Totale'
    },
    {
        id: 3,
        icon: icon3,
        simage: simg3,
        title: 'Controllo Smart Tuya',
        description: 'Gestisci tutto dallo smartphone: frequenza di pulizia, monitoraggio del peso del gatto e notifiche di manutenzione in tempo reale.',
        slug: 'Controllo-Smart'
    },
    {
        id: 4,
        icon: icon4,
        simage: simg4,
        title: 'Sicurezza ',
        description: 'A differenza dei modelli rotanti, il design a cupola fissa di Kleeo protegge il tuo gatto da ogni punto di pressione o schiacciamento. Sicurezza certificata al 100%.',
        slug: 'Vaccination'
    },


];
export default Services;